import useCounter from './CounterManager';

export default function useProxy() {
  const CounterManager = useCounter();
  return {
    run: (method, payload, onSuccess, onFailure, silent = false) => {
      if (!silent) {
        CounterManager.increment();
      }
      return gapi.client.script.scripts
        .run({
          // eslint-disable-next-line no-undef
          scriptId: SCRIPT_ID,
          resource: {
            function: method,
            parameters: Array.isArray(payload) ? payload : [payload],
            devMode: true,
          },
        })
        .then(({ result }) => {
          if (!silent) {
            CounterManager.decrement();
          }
          if (result.done) {
            onSuccess(result?.response?.result);
          } else {
            onFailure(result?.error);
          }
        })
        .catch((err) => {
          /*           if (!silent) {
            CounterManager.decrement();
          } */
          if (onFailure) {
            onFailure(err);
          }
        });
    },
  };
}
